/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

import React from "react";
import { observer } from "mobx-react";
import { router } from "dc-core";
import PropTypes from "prop-types";
import classNames from "classnames";
import PreviewContainer from "bundle/preview/react-component/preview/container/PreviewContainer";
import FileViewCSS from "app/preview/react-component/preview/container/file-view/FileView.css";

@observer
export default class FileViewContainer extends React.Component {
    static propTypes = {
        hideMainDiv: PropTypes.bool.isRequired,
        history: PropTypes.objectOf(PropTypes.any).isRequired,
    };

    componentDidMount() {
        router.setHistory(this.props.history);
    }

    render() {
        const middleClassList = [FileViewCSS.main];
        if (this.props.hideMainDiv) {
            middleClassList.push(FileViewCSS.hide);
        }
        return (
            <div className={ classNames(middleClassList) }>
                <div className={ FileViewCSS.middle }>
                    <PreviewContainer
                        { ...this.props }
                    />
                </div>
            </div>
        );
    }
}
